import { dayjsCustom } from '@/shared/utils/helpers/datetime-format';

import type { TShop } from '../../store/types';

export const convertShopsToTable = (items: TShop[]): TShop[] => {
  const shops = items.map((item) => ({
    ...item,
    created: dayjsCustom(item.created).format('DD.MM.YYYY / HH:mm'),
  }));

  return shops;
};
